import { API_ORIGIN } from "@/lib/config";

/**
 * Embeds the live Django-rendered showcase page in an iframe. The public page
 * keeps its Django template until its own redesign phase, so we render exactly
 * what will be published rather than a React lookalike.
 *
 * A `<base>` pointing at the API origin is injected so the template's
 * root-relative `/static/…` assets (its stylesheet + script) resolve against
 * Django rather than the SPA origin.
 */
export function LivePagePreview({ html, title }: { html: string; title: string }) {
  const srcDoc = html.replace(
    /<head(\s[^>]*)?>/i,
    (match) => `${match}<base href="${API_ORIGIN}/">`,
  );
  return (
    <iframe
      title={title}
      srcDoc={srcDoc}
      // `allow-scripts` powers the page's goal tabs/side-nav. We deliberately
      // omit `allow-same-origin`: with srcDoc the frame would otherwise inherit
      // the SPA's origin and its scripts could read our auth tokens from
      // localStorage. The preview only needs its own (sandboxed) scripts +
      // cross-origin assets (served with CORS), so a null origin is fine.
      sandbox="allow-scripts allow-popups"
      className="h-[72vh] w-full rounded-lg border bg-white"
    />
  );
}
